export default __webpack_public_path__ + "static/media/soccer.d719e631.jpg";